import React, {useState} from "react";
import {BACKEND_HOST, FORM_STATUSES, getDownloadFileLink, ROUTES} from "../utils/constants";

import IconCheck from "../assets/icon-check.svg";
import IconClose from "../assets/icon-close.svg";
import IconCloseWhite from "../assets/icon-close-white.svg";

import IconDownload from "../assets/icon-download.svg";
import IconDownloadDark from "../assets/icon-download-dark.svg";


const DATA_USES = {
  academics: "Academics",
  research: "R&D",
  business: "Business",
  journalism: "Journalism",
  govt: "Govt. Use",
  other: "Other",
};

const DATA_USES_KEYS = [
  "academics", "research", "business", "journalism", "govt", "other",
];

const DownloadForm = ({ onCloseClick, bmrcl = false, bmtc = false }) => {
  const [formStatus, setFormStatus] = useState(FORM_STATUSES.INITIAL);
  const [error, setError] = useState("");
  const [formOptions, setFormOptions] = useState({
    name: "",
    email: "",
    use: DATA_USES_KEYS[0],
    commercial: "commercial",
    bmtc: bmtc,
    bmrcl: bmrcl,
    terms: false,
    realtime: false,
  });

  const updateFormOption = (key, value) => {
    setFormOptions({
      ...formOptions,
      [key]: value,
    });
  }

  const submitDownloadForm = async (e) => {
    e.preventDefault();

    if(!formOptions.terms) {
      setError("Please agree to the terms & conditions to continue.");
      setFormStatus(FORM_STATUSES.ERROR);
      return;
    }

    // if(!formOptions.bmtc && !formOptions.bmrcl) {
    //   setError("No file selected. Please choose at least one data file above.");
    //   setFormStatus(FORM_STATUSES.ERROR);
    //   return;
    // }

    setFormStatus(FORM_STATUSES.SUBMITTING);
    setError("");
    const res = await fetch(`${BACKEND_HOST}/others/download_form`, {
      method: "POST",
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formOptions.name,
        email: formOptions.email,
        data_use: formOptions.use,
        commercial: formOptions.commercial,
        download_bmtc: formOptions.bmtc,
        download_bmrcl: formOptions.bmrcl,
        waitlist: formOptions.realtime,
      }),
    });
    const { status } = await res.json();
    if(status === "success") {
      setFormStatus(FORM_STATUSES.SUCCESS);
      // window.open(getDownloadFileLink(formOptions.bmtc, formOptions.bmrcl), "_blank");
    } else {
      setFormStatus(FORM_STATUSES.ERROR);
    }
  };

  return (
    <div className="modal" onClick={onCloseClick}>
      <div className="modal-inner" onClick={e => { e.stopPropagation(); }}>
        <div className="flex">
          <h3>Join the waitlist</h3>
          <div className="flex-gap" />
          <button className="modal-close" onClick={onCloseClick}>
            <img src={IconClose} alt="Close" className="light" />
            <img src={IconCloseWhite} alt="Close" className="dark" />
          </button>
        </div>

        {
          formStatus === FORM_STATUSES.SUCCESS && (
            <p>Thank you for submitting the form.<br/><br/>
            We received your response and shall contact you on the email entered when the data is made available.
              {/* Your file download should automatically start now.<br/>
              In case it hasn&apos;t started, please <a href={getDownloadFileLink(formOptions.bmtc, formOptions.bmrcl)} target="_blank" className="link">click here</a> to manually download it. */}
            </p>
          )
        }

        {
          formStatus !== FORM_STATUSES.SUCCESS && (
            <form onSubmit={submitDownloadForm}>
              <h4>About you</h4>
              <div className="two-input-wrapper mb">
                <div className="input-wrapper">
                  <label className="input-label">Name*</label>
                  <input
                    type="text"
                    required
                    className="input white"
                    value={formOptions.name}
                    onChange={e => updateFormOption("name", e.target.value)}
                  />
                </div>
                <div className="input-wrapper">
                  <label className="input-label">Email*</label>
                  <input
                    type="email"
                    required
                    className="input white"
                    value={formOptions.email}
                    onChange={e => updateFormOption("email", e.target.value)}
                  />
                </div>
              </div>


              <h4>What are you planning on using this data for?</h4>
              <div className="radio-wrapper">
                {
                  DATA_USES_KEYS.map(key => (
                    <div key={key} className="radio-item" onClick={() => updateFormOption("use", key)}>
                      <div className={`radio ${formOptions.use === key ? "checked" : ""}`}>
                        <img src={IconCheck} alt=""/>
                      </div>
                      {DATA_USES[key]}
                    </div>
                  ))
                }
              </div>

              <h4>Are you planning on using this for commercial purposes?</h4>
              <div className="radio-wrapper">
                <div className="radio-item" onClick={() => updateFormOption("commercial", "commercial")}>
                  <div className={`radio ${formOptions.commercial === "commercial" ? "checked" : ""}`}>
                    <img src={IconCheck} alt=""/>
                  </div>
                  Commercial use
                </div>
                <div className="radio-item" onClick={() => updateFormOption("commercial", "noncommercial")}>
                  <div className={`radio ${formOptions.commercial === "noncommercial" ? "checked" : ""}`}>
                    <img src={IconCheck} alt=""/>
                  </div>
                  Non-commercial use
                </div>
              </div>

              {/* <h4>Select files for download</h4>
              <div className="radio-wrapper">
                <div className="radio-item" onClick={() => updateFormOption("bmtc", !formOptions.bmtc)}>
                  <div className={`radio ${formOptions.bmtc ? "checked" : ""}`}>
                    <img src={IconCheck} alt=""/>
                  </div>
                  BMTC Static Data
                </div>
                <div className="radio-item" onClick={() => updateFormOption("bmrcl", !formOptions.bmrcl)}>
                  <div className={`radio ${formOptions.bmrcl ? "checked" : ""}`}>
                    <img src={IconCheck} alt=""/>
                  </div>
                  BMRCL Static Data
                </div>
              </div> */}

              <div className="mb">
                <div className="radio-item nonclickable">
                  <div className={`radio ${formOptions.terms ? "checked" : ""}`}
                       onClick={() => updateFormOption("terms", !formOptions.terms)}>
                    <img src={IconCheck} alt=""/>
                  </div>
                  <span>
                    I agree to the&nbsp;<a href={ROUTES.terms} onClick={onCloseClick}>terms & conditions</a>
                  </span>
                </div><br />
                {/* <div className="radio-item" onClick={() => updateFormOption("realtime", !formOptions.realtime)}>
                  <div className={`radio ${formOptions.realtime ? "checked" : ""}`}>
                    <img src={IconCheck} alt=""/>
                  </div>
                  I would like to join the waitlist for access to realtime data
                </div> */}
              </div>

              {
                formStatus === FORM_STATUSES.ERROR && (
                  <p className="error">{error || "Error occurred while submitting the form. Please check your internet connection and try again"}</p>
                )
              }

              <button
                type="submit"
                className="btn-download btn-login"
                disabled={formStatus === FORM_STATUSES.SUBMITTING}
              >
                {
                  formStatus === FORM_STATUSES.SUBMITTING ? (
                    <>
                      <div className="loader"/>
                      <span>Submitting form</span>
                    </>
                  ) : (
                    <>
                      <span>Submit</span>
                      <img src={IconDownload} alt="" className="light" />
                      <img src={IconDownloadDark} alt="" className="dark" />
                    </>
                  )
                }
              </button>
            </form>
          )
        }
      </div>
    </div>
  );
};

export default DownloadForm;
